import React, { useState } from 'react';
import styles from './AdminPostSingle.module.scss';
import AdminSinglePage from '../AdminSinglePage/AdminSinglePage';
import { userSingle } from '../../../redux/actions/user/userSingle';
import { resetUserSingle } from '../../../redux/slices/user.slice';
import { resetPostSingle } from '../../../redux/slices/app.slice';
import { postSingle } from '../../../redux/actions/app/postSingle';
import dayjs from 'dayjs';

const AdminPostSingle = () => {
  const data = [
    {
      label: 'Фото',
      type: 'image',
      name: 'attachment',
      width: '600px',
    },
    [
      {
        type: 'image',
        name: 'avatar',
        width: '40px',
        grid: '40px 1fr',
      },
      {
        label: 'Создатель',
        type: 'text',
        name: 'user',
        disabled: true,
      },
    ],
    {
      label: 'Описание',
      type: 'textarea',
      name: 'text',
      disabled: true,
    },
    {
      label: 'Дата публикации',
      type: 'text',
      name: 'createdAt',
      disabled: true,
    },
  ];
  const [fields, setFields] = useState([]);
  const onFormatData = ({ post: { attachment, text, creator, createdAt } }) => {
    setFields(data);
    return { attachment, text, user: `${creator?.lastName} ${creator?.firstName}`, avatar: creator?.avatar, createdAt: dayjs(createdAt).format('DD.MM.YYYY HH:mm') };
  };
  const deleteProps = { successText: 'Пост удален', confirmTitle: `Вы уверены что хотите удалить пост`, confirmText: 'Комментарии также будут удалены', status: 'DELETED' };
  const blockProps = { successText: 'Пост заблокирован', confirmTitle: `Вы уверены что хотите заблокировать пост`, confirmText: 'Комментарии также будут заблокированы', status: 'BLOCKED' };
  const unblockProps = { successText: 'Пост разблокирован', confirmTitle: `Вы уверены что хотите разблокировать пост`, confirmText: 'Комментарии также будут разблокированы', status: 'ACTIVE' };
  return (
    <>
      <AdminSinglePage reset={resetPostSingle} fetch={postSingle} sliceName={'app'} actionName={'postSingle'} onFormatData={onFormatData} fields={fields} deleteProps={deleteProps} pathList="/admin/posts" blockProps={blockProps} unblockProps={unblockProps} propName={'post'} type={'POST'} />
    </>
  );
};

export default AdminPostSingle;
